export const getLocalImage = (name: string) => {
    return `${process.env.PUBLIC_URL}/media/${name}`;
};